module.exports = __webpack_public_path__ + "static/media/empty.cb0b51aea24d886b887c45554e67c365.svg";